import { render, staticRenderFns } from "./EtaMedicao.vue?vue&type=template&id=edb2a520&scoped=true&"
import script from "./EtaMedicao.vue?vue&type=script&lang=js&"
export * from "./EtaMedicao.vue?vue&type=script&lang=js&"
import style0 from "./EtaMedicao.vue?vue&type=style&index=0&id=edb2a520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb2a520",
  null
  
)

export default component.exports